import * as React from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
  size?: number
}

function LoadingSpinner({
  title,
  titleId,
  size = 40,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <>
      <svg width={size} height={size} viewBox="0 0 50 50" aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M43.935 25.145c0-10.318-8.364-18.683-18.683-18.683-10.318 0-18.683 8.365-18.683 18.683h4.068c0-8.071 6.543-14.615 14.615-14.615s14.615 6.543 14.615 14.615h4.068z">
          <animateTransform
            attributeType="xml"
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="0.6s"
            repeatCount="indefinite"
          />
        </path>
      </svg>

      <style jsx>{`
        svg {
          display: block;
          margin: 0 auto;
        }
      `}</style>
    </>
  )
}

export default LoadingSpinner
